import { authCheck } from "./authCheck";
import paths from "./paths";

export default [
    {
        path: `${paths.questionaires.add}`,
        name: "Adicionar Questionário",
        component: () => import("@/views/Questionaire/AddQuestionaire/AddQuestionaireScreen.vue"),
        props: true,
        beforeEnter: authCheck,
    },
    {
        path: `${paths.questionaires.list}`,
        name: "Lista de questionários",
        component: () => import("@/views/Questionaire/QuestionairesList/QuestionairesList.vue"),
        props: true,
        beforeEnter: authCheck,
    },
    {
        path: `${paths.questionaires.detail}/:id`,
        name: "Detalhe do Questionário",
        component: () => import("@/views/Questionaire/QuestionaireDetail/QuestionaireDetailScreen.vue"),
        props: true,
        beforeEnter: authCheck,
    },
]